// extracted by mini-css-extract-plugin
export var linkText = "_m5-0";